import { http, authHeader } from '@/http-commons';

// axios default array serializer emits tipoSalidaId[]=1 (bracket notation),
// Tomcat rejects unencoded [ ] in request target. Backend wants repeated key: tipoSalidaId=1&tipoSalidaId=5
function serializeRepeatedParams(params) {
    const usp = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '') return;
        if (Array.isArray(value)) {
            value.forEach(v => usp.append(key, v));
        } else {
            usp.append(key, value);
        }
    });
    return usp.toString();
}

class VentaDataService {
    create( venta, productCart ){
        const cartDTO = { venta, productCart };
        return http.post('api/v1/venta/create', cartDTO, { headers : authHeader() });
    }
    table( params ){
        return http.get('api/v1/venta/table', { params, headers : authHeader() });
    }
    show( ventaId ){
        return http.get(`api/v1/venta/show/${ventaId}`, {headers : authHeader() });
    }
    update( ventaId, venta ){
        return http.put(`api/v1/venta/update/${ventaId}`, venta, { headers : authHeader() });
    }
    delete( ventaId ){
        return http.delete(`api/v1/venta/delete/${ventaId}`, { headers: authHeader() });
    }
    detalleVenta( ventaId ){
        return http.get(`api/v1/venta/jsonVenta/${ventaId}`, { headers: authHeader() });
    }
    ultimateSell(){
        return http.get(`api/v1/venta/ultimateSell`, { headers: authHeader() });
    }
    // Venta de traslado.
    ventaTrasladoEnviado( sucursalRecibeId ){
        return http.get(`api/v1/venta/finvVentaTrasladoEnviado/${sucursalRecibeId}`, { headers: authHeader() });
    }
    downloadVentaExcelByDay( params ){
        return http.get(`api/v1/venta/downloadVentaExcelByDay`, { params, headers: authHeader(), responseType: 'blob' });
    }
    downloadVentaServiceReport( params ){
        return http.get(`api/v1/venta/downloadVentaServiceReport`, { params, paramsSerializer: serializeRepeatedParams, headers: authHeader(), responseType: 'blob' });
    }
    printVentaServiceReport( params ){
        return http.get(`api/v1/venta/printVentaServiceReport`, { params, paramsSerializer: serializeRepeatedParams, headers: authHeader(), responseType: 'blob' });
    }
    
    findByCreditClient(clientId){
        return http.get(`api/v1/venta/findByCreditClient/${clientId}`, { headers: authHeader() });
    }

    findByCreditEmployee(employeeId){
        return http.get(`api/v1/venta/findByCreditEmployee/${employeeId}`, { headers: authHeader() });
    }

    findByCashRegister(cashRegisterId){
        return http.get(`api/v1/venta/findVentaByCashRegister/${cashRegisterId}`, { headers: authHeader() });
    }
    
    downloadSellDebts( params ){
        return http.get(`api/v1/venta/downloadSellDebts`, { params, headers: authHeader(), responseType: 'blob' });
    }
    
    downloadTicket( ventaId ){
        return http.get(`api/v1/venta/pdf/${ventaId}`, { headers: authHeader(), responseType: 'blob' });
    }
    printSellDebts( params ){
        return http.get(`api/v1/venta/printSellDebts`, { params, headers: authHeader(), responseType: 'blob' });
    }
    printAccountStatement( params ){
        return http.get(`api/v1/venta/printAccountStatement`, { params, headers: authHeader(), responseType: 'blob' });
    }
    printTicket( ventaId, params ){
        return http.get(`api/v1/venta/printTicket/${ventaId}`, { params, headers: authHeader(), responseType: 'blob' });
    }
    printSell(params){
        return http.get(`api/v1/venta/printSell`, { params, headers: authHeader(), responseType: 'blob' });
    }
    printSellByCategoriesProduct(params){
        return http.get(`api/v1/venta/printSellByCategoriesProduct`, { params, headers: authHeader(), responseType: 'blob' });
    }
    cancel( ventaId ){
        return http.post(`api/v1/venta/cancel/${ventaId}`, { headers: authHeader() });
    }

    importExcelAccount(file){
        const formData = new FormData();
        formData.append('file', file);
        return http.post(`api/v1/venta/importExcelAccount`, formData, { headers: authHeader() });
    }
    importJsonAccount(jsonArray){
        return http.post(`api/v1/venta/importJsonAccount`, jsonArray, { headers: authHeader() });
    }

}
export default new VentaDataService();